import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const FunFacts = () => {
  const [facts, setFacts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFacts = async () => {
      try {
        const res = await fetch('https://spaceportfolio-api.rajansudhan0.workers.dev/api/resume');
        const data = await res.json();
        
        // Filter out the Fun Facts from the general resume items payload
        const funFacts = data.filter(item => item.type === 'fun_fact').sort((a, b) => a.display_order - b.display_order);
        setFacts(funFacts);
      } catch (err) {
        console.error('Failed to load fun facts:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchFacts();
  }, []);

  if (!loading && facts.length === 0) return null;

  return (
    <section className="py-16 lg:py-24 bg-background border-t border-white/5 relative overflow-hidden">
      {/* Background Decor */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-accent/5 rounded-full blur-[100px] pointer-events-none -translate-y-1/2 translate-x-1/2"></div>
      
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="font-heading text-3xl lg:text-4xl font-bold text-text-primary mb-6">
            Beyond the Resume
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto leading-relaxed">
            A few quick insights into my passions, milestones, and the things that keep me inspired every day.
          </p>
        </div>

        {loading ? (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[1, 2, 3].map(i => (
              <div key={i} className="h-48 bg-white/5 animate-pulse rounded-2xl border border-white/10"></div>
            ))}
          </div>
        ) : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {facts.map((fact) => (
              <div 
                key={fact.id} 
                className="group bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-6 hover:shadow-accent/10 transition-smooth relative overflow-hidden"
              >
                {/* Subtle gradient hover effect */}
                <div className="absolute inset-0 bg-gradient-to-br from-accent/0 to-accent/5 opacity-0 group-hover:opacity-100 transition-smooth pointer-events-none"></div>
                
                <div className="flex items-start gap-4 relative z-10">
                  <div className="w-12 h-12 flex-shrink-0 bg-accent/10 text-accent rounded-xl flex items-center justify-center group-hover:scale-110 group-hover:bg-accent group-hover:text-white transition-smooth duration-300">
                    <Icon name={fact.badge || 'Sparkles'} size={24} />
                  </div>
                  <div>
                    <h3 className="font-heading text-xl font-bold text-text-primary mb-2 group-hover:text-accent transition-smooth">
                      {fact.title}
                    </h3>
                    <p className="text-text-secondary leading-relaxed text-sm">
                      {fact.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default FunFacts;
